export default {
    meEndpoint: '/api/me',
    loginEndpoint: '/api/signin',
    logoutEndpoint: '/api/signout',
    registerEndpoint: '/api/signup',
    storageTokenKeyName: 'accessToken'
} 
